<h3>Version</h3>
<p>
  <mat-checkbox #languageOverride [checked]="!!composition.screen.availableLanguages"
                [disabled]="composition.screen.availableLanguages"></mat-checkbox>

  <mat-list>
    <mat-list-item>
<p>Available and disabled Languages (you can disable languages to use them in backend only)</p>
</mat-list-item>
<mat-list-item *ngFor="let language of availableLanguages; let i = index">
  <mat-checkbox (change)="assignLanguages()" [(ngModel)]="language.checked"
                [disabled]="!languageOverride.checked">{{language.title}}</mat-checkbox>
  <mat-checkbox (change)="disableLanguages()" [(ngModel)]="availableLanguages[i].disabled"
                [disabled]="!languageOverride.checked || !language.checked">disabled
  </mat-checkbox>
</mat-list-item>
</mat-list>
<smart-input [(model)]="composition" jsonPointerKey="/screen" key="masterLanguage"></smart-input>
</p>
